import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRapaNui = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_2122)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#FCFCFC"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M15.6522 9.91302V10.9565H17.0843C16.4867 11.7871 15.6906 12.4652 14.7656 12.9218C14.5284 12.6753 14.1952 12.5217 13.8261 12.5217C13.2038 12.5217 12.6837 12.9576 12.5534 13.5407C12.3711 13.5567 12.1865 13.5652 12 13.5652C11.8135 13.5652 11.629 13.5566 11.4466 13.5407C11.3163 12.9577 10.7962 12.5217 10.174 12.5217C9.80482 12.5217 9.47177 12.6753 9.2344 12.9218C8.30946 12.4653 7.51343 11.7871 6.91577 10.9565H8.34785V9.91302H4.69568C4.69568 13.947 7.96601 17.2174 12 17.2174C16.0341 17.2174 19.3044 13.947 19.3044 9.91302H15.6522Z",
			fill: "#D80027"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_2122",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgRapaNui;
